import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Bureau } from '../_models';
import { BaseService } from './base.service';

@Injectable()
export class BureauService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/bureaus`);
  }

  create(company_id: string, bureau: Bureau): Observable<any> {
    return super.create(bureau, { company_id: company_id }).pipe(
      map(res => new Bureau().deserialize(res))
    );
  }

  update(company_id: string, bureau: any): Observable<any> {
    return super.update(bureau, { company_id: company_id }).pipe(
      map(res => new Bureau().deserialize(res))
    );
  }
}
